'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';


interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
  { label: 'Home', href: '/homepage' },
  { label: 'Solutions', href: '/solutions-overview' },
  { label: 'Results & ROI', href: '/results-and-roi' },
  { label: 'Assessment', href: '/ai-readiness-assessment' },
  { label: 'Partnership Inquiry', href: '/partnership-inquiry' }];


  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleMoreMenu = () => {
    setIsMoreMenuOpen(!isMoreMenuOpen);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 bg-card shadow-md ${className}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link href="/homepage" className="flex items-center">
            <div className="flex items-center space-x-2">
              <span className="font-bold text-[28px] text-blue-950">MindShift AI</span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navigationItems.map((item) =>
            <Link
              key={item.href}
              href={item.href}
              className="text-sm font-medium text-foreground hover:text-primary transition-colors duration-300">

                {item.label}
              </Link>
            )}
          </nav>

          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 text-foreground hover:text-primary transition-colors duration-300"
            aria-label="Toggle mobile menu">

            <Icon
              name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
              size={24} />

          </button>
        </div>
      </div>

      {isMobileMenuOpen &&
      <div className="lg:hidden bg-card border-t border-border">
          <nav className="container mx-auto px-4 py-4 space-y-2">
            {navigationItems.map((item) =>
          <Link
            key={item.href}
            href={item.href}
            className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted rounded-lg transition-colors duration-200"
            onClick={() => setIsMobileMenuOpen(false)}>

                {item.label}
              </Link>
          )}
          </nav>
        </div>
      }
    </header>);

};

export default Header;